<template>
  <div class="web-004-page contact-us-mobile-004">
    <carousel
      v-if="cp_carouselImages.length"
      :list="cp_carouselImages"
    />

    <div class="title">
      教育新模式 投资新风口
    </div>
    <div class="middle-imgs">
      <img
        src="~@/assets/web004/contactUs/m-middle1.png"
      >
      <img
        src="~@/assets/web004/contactUs/m-middle2.png"
      >
      <img
        src="~@/assets/web004/contactUs/m-middle3.png"
      >
    </div>
    <div class="bottom-imgs">
      <img
        src="~@/assets/web004/contactUs/m-bottom1.png"
      >
      <img
        src="~@/assets/web004/contactUs/m-bottom2.png"
      >
      <img
        src="~@/assets/web004/contactUs/m-bottom3.png"
      >
      <img
        src="~@/assets/web004/contactUs/m-bottom4.png"
      >
    </div>
    <div class="title">
      商业赋能
    </div>
    <img
      src="~@/assets/web004/contactUs/m-core.png"
      style="width: 100%; padding: 0 16px; box-sizing: border-box;"
    >
    <div
      class="ruleForm"
    >
      <div class="title">
        {{ dialogVisible ? '期待与您合作' : '联系我们' }}
      </div>
      <el-form
        v-if="!dialogVisible"
        ref="ruleFormRef2"
        :model="ruleForm"
        :rules="rules"
        label-width="auto"
        size="small"
        status-icon
        label-position="top"
      >
        <el-form-item
          label="您的姓名(已加密，请放心填写)"
          prop="name"
          style="margin-bottom: 16px;"
        >
          <el-input
            v-model="ruleForm.name"
          />
        </el-form-item>
        <el-form-item
          label="您的电话(已加密，请放心填写)"
          prop="phone"
          style="margin-bottom: 22px;"
        >
          <el-input
            v-model="ruleForm.phone"
            type="number"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            class="submit"
            :loading="loading"
            @click="submitForm('ruleFormRef2')"
          >
            点击领取项目合作资料
          </el-button>
        </el-form-item>
      </el-form>

      <div
        v-if="dialogVisible"
        class="qr-container"
      >
        <el-image
          :src="'./static/layout/contact.png'"
          class="img"
          width="192px"
          height="192px"
        >
          <div
            slot="error"
            class="image-slot"
          >
            <i class="el-icon-picture-outline" />
          </div>
        </el-image>
      </div>

      <div
        v-if="dialogVisible"
        class="scan-code"
      >
        扫码添加合作顾问
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../proxy';
import carousel from '../../components/carousel.vue';
export default {
    name: 'ContactUs',
    components: {
        carousel,
    },
    data () {
        var validatePhone = (rule, value, callback) => {
            let reg = /^1[0-9]{10,10}$/;
            if (!reg.test(value)) {
                callback(new Error('请输入正确的手机号'));
            } else {
                callback();
            }
        };
        return {
            carouselImages: [],
            loading: false,
            dialogVisible: false,
            ruleForm: {
                name: '',
                phone: '',
            },
            rules: {
                name: [
                    { required: true, message: '请输入您的姓名', trigger: 'blur' },
                    { min: 2, max: 20, message: '长度在20个字符', trigger: 'blur' },
                ],
                phone: [
                    { required: true, message: '请输入您的电话', trigger: 'change' },
                    { validator: validatePhone, trigger: 'blur' },
                ],
            },
        };
    },
    computed: {
        flatTreeList () {
            return this.$store.getters['system/getFlatTreeList'];
        },
        cp_carouselImages () {
            return this.carouselImages.filter(itm => itm.status === 1 && [0, 2].includes(itm.clientType));
        },
    },
    watch: {
        async flatTreeList (val) {
            this.getCarouselImages();
        },
    },
    mounted () {
        this.getCarouselImages();
    },
    methods: {
        async getCarouselImages () {
            if (this.flatTreeList.length) {
                const { catalogId, siteId } = this.$route.query;
                const item = this.flatTreeList.find(itm => +itm.catalogId === +catalogId);
                if (!item || item.rotation === 0) return;
                const res = item.rotation === 1 ? await api.getRotationList({ siteId, pageNo: 1, pageSize: 999 }) : await api.getCatalogRotationList({ catalogId });
                if (res.errcode === 0) {
                    this.carouselImages = res.data.list || res.data;
                } else {
                    this.$message.error(res.errmsg);
                }
            }
        },
        envjudge () {
            var isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
            var isWx = /micromessenger/i.test(navigator.userAgent);
            var isComWx = /wxwork/i.test(navigator.userAgent);

            if (isComWx && isMobile) {
                return 1001; // 手机端企业微信
            } else if (isComWx && !isMobile) {
                return 1003; // PC端企业微信
            } else if (isWx && isMobile) {
                return 1002; // 手机端微信
            } else if (isWx && !isMobile) {
                return 1003; // PC端微信
            } else {
                return 1004; // 其他平台
            }
        },
        submitForm (formName) {
            this.loading = true;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let param = {
                        realName: this.ruleForm.name,
                        phone: this.ruleForm.phone,
                        appCode: 1001, // 【非必须】应用编码 1001-智习室
                        sourceCode: 1003, // 【非必须】来源编码 1001-链接A 1002-链接B 1003-官网
                        channelCode: this.envjudge(), // 渠道编码 1001-企微 1002-微信 1003-H5 1004-PC
                    };
                    api.collection(param).then(r => {
                        if (r.errcode === 0) {
                            this.$refs[formName].resetFields();
                            this.showMessage();
                        } else {
                            this.$message({ message: r.msg, type: 'warning' });
                        }
                    }).finally(f => {
                        this.loading = false;
                    });
                } else {
                    this.loading = false;
                    return false;
                }
            });
        },

        showMessage () {
            this.dialogVisible = true;
        },

        handleClose (done) {
            done();
        },
    },
};
</script>

<style scoped lang="scss">
.web-004-page {
    * {
        box-sizing: border-box;
    }
    background: linear-gradient(#e0e4ff, #fff);
    .title {
        width: 100%;
        text-align: center;
        font-size: 14px;
        font-weight: 600;
        line-height: 50px;
    }
    .middle-imgs {
        width: 100%;
        padding: 0 16px;
        box-sizing: border-box;
        >img {
            width: 100%;
            margin: 5px 0;
        }
    }
    .bottom-imgs {
        width: 100%;
        padding: 0 16px;
        display: flex;
        justify-content: space-between;
        margin-top: 5px;
        box-sizing: border-box;
        >img {
            width: 23%;
        }
    }
    .ruleForm {
        width: 100%;
        padding: 0 16px;
        box-sizing: border-box;
        .title {
            font-size: 14px;
            font-weight: bold;
            text-align: center;
            line-height: 50px;
        }
        ::v-deep {
            .el-input__inner {
                border: 1px solid #C5C5C7;
                border-radius: 4px;
                // box-shadow: 0px 6px 12px 0px rgba(0,0,0,0.2);
                line-height: 34px;
                height: 34px;
            }

            .el-form-item__label {
                line-height: 20px;
                padding: 0;
                font-size: 12px;
                color: #343444;
                margin-bottom: 10px;
            }
            .el-form-item__error {
                line-height: 20px;
            }
            input[type="number"]::-webkit-outer-spin-button,
            input[type="number"]::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
            }
        }

        .img {
            width: 100%;
            text-align: center;
        }

        .submit {
            background: linear-gradient( 180deg, #FF8800 0%, #FE5000 100%);
            // box-shadow: 0px 6px 12px 0px rgba(0,0,0,0.2);
            border-radius: 4px;
            width: 100%;
            font-size: 14px;
            color: #FFFFFF;
            margin-bottom: 20px;
            height: 40px;
            border: none;
            &:hover,&:active {
                border-color: none;
            }
        }
    }
    .qr-container {
        text-align: center;
        width: calc(100% - 40px);
        background: #D8D8D8;
        box-shadow: 0px 6 12px 0px rgba(0,0,0,0.2);
        border-radius: 4px;
        user-select: none;
        margin: 0 auto;
    }

    .scan-code {
        text-align: center;
        line-height: 40px;
        font-size: 12px;
    }
}
</style>
<style lang="scss">
.contact-us-mobile-004 {
    input,textarea,.ivu-select{
        font-size: 12px !important;
    }
}
</style>
